<template>
  <div>
    <Create :createDialog="createDialog" @close="close" @createdLead="createdLead" />
    <v-card>
      <v-card-text class="pa-0">
        <v-layout row align-center>
          <v-btn flat fab small color="grey darken-4" @click="$router.push({ path: '/leads' })">
            <v-icon>home</v-icon>
            <span>Leads</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn flat color="teal" dark @click="add">New</v-btn>
          <v-btn flat color="teal" dark @click="$router.push({ path: '/leads/list' })">List</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
    <router-view></router-view>
  </div>
</template>
<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import leadStore from "./store.js";

const Create = () => import("../Leads/components/Create");

export default {
  name: 'leads',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("lead", leadStore);
  },
  data() {
    return {
      active: null,
      createDialog: false
    };
  },
  methods: {
    createdLead() {
      this.close();
      this.getList();
    },
    add() {
      this.createDialog = true;
    },
    close() {
      this.createDialog = false;
    }
  },
  components: {
    Create,
  }
};
</script>
